import AccountsPage from '../Accounts'

/**
 * Business Accounts page — re-uses the shared AccountsPage component
 * with isPersonal=false so it only shows/creates business-scoped Plaid items.
 */
export default function BizAccounts() {
  return <AccountsPage isPersonal={false} />
}
